import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { JournalsApi } from '../../../apis/JournalsApi/JournalsApi.ts';

export const priorityQuestionKeys = {
    all: ['journals', 'priorityQuestions'] as const,
    byJournalAndPatient: (journalId: number, patientId: number) =>
        [...priorityQuestionKeys.all, journalId, patientId] as const,
};

export const usePatientPriorityQuestions = (journalId: number, patientId: number) => {
    return useQuery({
        queryKey: priorityQuestionKeys.byJournalAndPatient(journalId, patientId),
        queryFn: () => JournalsApi.getPatientPriorityQuestions(journalId, patientId),
        enabled: !!journalId && !!patientId,
    });
};

export const useSetPatientPriorityQuestion = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ patientId, questionId, isPriority }: { patientId: number; questionId: number; isPriority: boolean }) =>
            JournalsApi.setPatientPriorityQuestion(patientId, questionId, isPriority),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: priorityQuestionKeys.all });
        },
    });
};
